import { gql } from "@grandvisionhq/graphql";
import PlaceByIdFragment from "../../../fragments/operations/fragments/place-by-id.js";
const GET_PLACE_BY_ID = gql`
  query GetPlaceById($id: String!) {
    placeById(id: $id) {
      ...PlaceById
    }
  }
  ${PlaceByIdFragment}
`;
export {
  GET_PLACE_BY_ID
};
//# sourceMappingURL=get-place-by-id.js.map
